var invoke = require('./invoke')

var invokeMap = invoke

module.exports = invokeMap
